export default {
  // 正式地址
  baseUrl: 'https://ai-api.deepcity.cn/',
  wsUrl: 'wss://www.ailonglong.com/wss',
  // 本次调试
  // baseUrl: 'http://localhost:8080/',
  // wsUrl: 'ws://localhost:3000',

  // 灰度开关：AI 对话走新版 WebSocket。双轨运行至少 2 周，稳定后删除旧 SSE 路径
  // true  → agent-chat.vue 走 Node WS（chatType=agent）
  // false → 走旧 saveMsg + sendOpen(SSE) 双接口
  useWsAgentChat: true,
}
